<!-- 漏检考题选择器 -->
<template>
    <div class="m-theoryGraphicSelector">
        <el-dialog title="选择物品图像"
                   width="75%"
                   top="10vh"
                   custom-class="graphic-selector-dialog"
                   :visible.sync="visible"
                   :close-on-click-modal="false"
                   :append-to-body="true"
                   :modal-append-to-body="true">
            <div class="selector-container">
                <el-tabs class="selector-area" v-model="tab" type="border-card">

                    <!-- 漏检图像库 -->
                    <el-tab-pane label="漏检图像库" name="1">
                        <el-form class="selector-query" :model="omitSearch" :inline="true" size="mini" @submit.native.prevent>
                            <el-form-item label="物品名称">
                                <el-input v-model="omitSearch.imageName" :placeholder="$t('tip.name')"
                                          @keyup.enter.native="queryMap(1)" clearable></el-input>
                            </el-form-item>

                            <select-multi-mark-knowledge v-model="omitSearch.knowledgeIds"></select-multi-mark-knowledge>

                            <el-form-item>
                                <el-button type="primary" @click="queryMap(1)" round>{{$t('c.query')}}</el-button>
                            </el-form-item>
                        </el-form>

                        <data-tables-server class="map-table"
                                            ref="omitTable"
                                            :data="omitData"
                                            :table-props="tableProps"
                                            :total="omitPage.total"
                                            :current-page.sync="omitPage.current"
                                            :page-size="omitPage.size"
                                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                            @query-change="onPage"
                                            @selection-change="handleSelectionChange"
                                            v-viewer
                        >
                            <!-- column checkbox -->
                            <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"></el-table-column>
                            <el-table-column prop="imageName" label="物品名称" align="center"></el-table-column>
                            <el-table-column prop="knowledgeName" label="物品种类" align="center"></el-table-column>

                            <el-table-column prop="markerUrl" label="物品图片" align="center" min-width="300">
                                <template #default="{row}">
                                    <div class="img-map">
                                        <img :src="row.markerUrl" alt="物品图片">
                                    </div>
                                </template>
                            </el-table-column>
                        </data-tables-server>
                    </el-tab-pane>

                    <!-- 优质图像库 -->
                    <el-tab-pane label="优质图像库" name="2">
                        <el-form class="selector-query" :model="goodSearch" :inline="true" size="mini" @submit.native.prevent>
                            <el-form-item label="物品名称">
                                <el-input v-model="goodSearch.imageName" :placeholder="$t('tip.name')"
                                          @keyup.enter.native="queryMap(1)" clearable></el-input>
                            </el-form-item>

                            <select-multi-mark-knowledge v-model="goodSearch.knowledgeIds"></select-multi-mark-knowledge>

                            <el-form-item label="物品类型">
                                <el-radio-group v-model="goodSearch.isSafe">
                                    <el-radio-button label="">全部</el-radio-button>
                                    <el-radio-button :label="true">安全</el-radio-button>
                                    <el-radio-button :label="false">嫌疑</el-radio-button>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" @click="queryMap(1)" round>{{$t('c.query')}}</el-button>
                            </el-form-item>
                        </el-form>

                        <data-tables-server class="map-table"
                                            ref="goodTable"
                                            :data="goodData"
                                            :table-props="tableProps"
                                            :total="goodPage.total"
                                            :current-page.sync="goodPage.current"
                                            :page-size="goodPage.size"
                                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                            @query-change="onPage"
                                            @selection-change="handleSelectionChange"
                                            v-viewer
                        >
                            <!-- column checkbox -->
                            <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"></el-table-column>
                            <el-table-column prop="imageName" label="物品名称" align="center"></el-table-column>
                            <el-table-column prop="knowledgeName" label="物品种类" align="center"></el-table-column>

                            <el-table-column prop="markerUrl" label="物品图片" align="center" min-width="300">
                                <template #default="{row}">
                                    <div class="img-map">
                                        <img v-if="row.isMark" :src="row.markerUrl" alt="">
                                        <img v-else :src="row.baseUrl" alt="">
                                    </div>
                                </template>
                            </el-table-column>
                        </data-tables-server>
                    </el-tab-pane>
                </el-tabs>

                <div class="result-area">
                    <div class="tips">
                        已选择：<span>{{selectAll.length}}</span> 个图像
                    </div>
                    <el-form :model="ruleForm"
                             :rules="rules"
                             ref="ruleForm"
                             label-width="100px"
                             label-position="top"
                             size="small"
                             class="result-form">
                        <el-form-item label="考核形式" prop="pattern" required>
                            <el-radio-group v-model="ruleForm.pattern" prop="pattern">
                                <el-radio-button :label="1">快速判断</el-radio-button>
                                <el-radio-button :label="2">位置标记</el-radio-button>
                                <el-radio-button :label="3">位置标记及类型选择</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="题目名称" prop="topicTitle">
                            <el-input type="textarea"
                                      v-model="ruleForm.topicTitle"
                                      :autosize="{ minRows: 3, maxRows: 5}"
                                      :placeholder="$t('tip.paperName')"
                                      clearable></el-input>
                        </el-form-item>
                    </el-form>

                    <el-button @click="savePaper"
                               class="btn-save"
                               :loading="submitLoading"
                               :disabled="!selectAll.length"
                               size="medium" type="primary">保存
                    </el-button>
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import SelectMultiMarkKnowledge from "@/components/SelectMultiMarkKnowledge"

export default {
    props: {
        selectorDialog: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        SelectMultiMarkKnowledge
    },

    data() {
        return {
            visible: false,
            tab: '1',
            omitSearch: {
                imageName: '',
                knowledgeIds: [],
            },
            goodSearch: {
                imageName: '',
                knowledgeIds: [],
                isSafe: ''
            },
            omitData: [],
            goodData: [],
            tableProps: {
                stripe: true,
                rowKey: row => row.id,
                height: '60vh'
            },
            omitPage: {
                current: 1,
                size: 20,
                total: 0,
            },
            goodPage: {
                current: 1,
                size: 20,
                total: 0,
            },

            ruleForm: {
                topicTitle: '',
                pattern: 1,
            },
            rules: {
                topicTitle: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
            },
            submitLoading: false,

            selectOmit: [],
            selectGood: [],
            selectAll: [],
        }
    },

    watch: {
        'ruleForm.pattern': {
            handler(v) {
                let defaultTitle = {
                    1: '请判断是安全还是嫌疑',
                    2: '请判断是安全还是嫌疑，若为嫌疑请标出嫌疑物位置',
                    3: '请判断是安全还是嫌疑，若为嫌疑请标出嫌疑物位置，并选择类型'
                }

                this.ruleForm.topicTitle = defaultTitle[v]
            },
            immediate: true
        },
        visible(val) {
            // 打开
            if (val) {
                this.initDialog()
                // 关闭
            } else {
                this.onClose()
                this.$emit('update:selectorDialog', false)
            }
        },
        selectorDialog() {
            this.visible = this.selectorDialog;
        }
    },

    methods: {
        initDialog() {
            this.queryOmit()
            this.queryGood()
        },

        onPage({type, page, pageSize}) {
            if (type === 'init') return

            if (this.tab == '1') {
                this.omitPage.current = page
                this.omitPage.size = pageSize
            } else {
                this.goodPage.current = page
                this.goodPage.size = pageSize
            }

            this.queryMap()
        },
        queryMap(num) {
            if (this.tab == '1') {
                this.queryOmit(num)
            } else {
                this.queryGood(num)
            }
        },
        queryOmit(num) {
            if (num) this.omitPage.current = num

            let searchData = {
                ...this.omitSearch,
                PageNO: this.omitPage.current,
                Limit: this.omitPage.size,
                source: 1,
            }

            let request = this.$api.queryOmit
            request(searchData).then((res) => {
                this.omitData = res.package
                this.omitPage.total = res.total
            })
        },
        queryGood(num) {
            if (num) this.goodPage.current = num

            let searchData = {
                ...this.goodSearch,
                PageNO: this.goodPage.current,
                Limit: this.goodPage.size,
                isCompletion: true,
                source: 2,
            }

            let request = this.$api.queryOmit
            request(searchData).then((res) => {
                this.goodData = res.package
                this.goodPage.total = res.total
            })
        },

        savePaper() {
            let paperId = this.$parent.editData && this.$parent.editData.id || 0
            let submitData = {
                ...this.ruleForm,
                paperId,
                imageIds: this.selectAll
            }

            this.$refs['ruleForm'].validate((valid) => {
                if (!valid) return

                this.submitLoading = true

                this.$api.addTheoryGraphicInPaper(submitData).then(res => {
                    let data = res.package

                    this.$emit('selector-save', data)

                    this.submitLoading = false
                    this.visible = false

                }).catch(error => this.submitLoading = false)

            })
        },

        handleSelectionChange(arr) {
            if (this.tab == '1') {
                this.selectOmit = arr.map(v => v.imageId)
            } else {
                this.selectGood = arr.map(v => v.imageId)
            }

            this.selectAll = [...this.selectOmit, ...this.selectGood]
        },

        onClose() {
            let omitTable = this.$refs.omitTable.$refs.elTable
            let goodTable = this.$refs.goodTable.$refs.elTable
            omitTable.clearSelection()
            goodTable.clearSelection()

            this.omitSearch =  {
                imageName: '',
                knowledgeIds: [],
            }

            this.goodSearch = {
                imageName: '',
                knowledgeIds: [],
                isSafe: ''
            }

            this.$refs["ruleForm"].clearValidate()
        }
    },
}
</script>

<style lang="scss">
@import '~@/style/const.scss';

.m-theoryGraphicSelector {

}

.graphic-selector-dialog {
    @include scrollbar();
    min-width: 1100px;
    .el-dialog__header {
        padding: 8px 15px;
    }

    .selector-container {
        display: flex;
    }

    .selector-area {
        flex: 1;
        overflow: hidden;
    }

    .selector-query {

    }

    .map-table {
        td {
            padding: 0;
        }

        .img-map {
            img {
                max-height: 100px;
                cursor: pointer;
            }
        }

        .el-table__body-wrapper {
            td:first-child .cell {
                padding: 0;
            }

            .el-table-column--selection .el-checkbox {
                height: 120px;
                width: 100%;
            }
        }
    }

    .result-area {
        width: 350px;
        flex-shrink: 0;
        padding: 0 0 20px 30px;
        .tips {
            height: 40px;
            line-height: 40px;
            padding-left: 10px;
            margin-bottom: 18px;
            background-color: #F5F7FA;
            span {
                color: $blue;
            }
        }
        .result-form {
            padding: 0 10px;
        }
        .btn-save {
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
